import IJobGroupWithTitlesVO from '@domain/vo/match/IJobGroupWithTitlesVO';

export default class JobGroupSTitleRq {
  jobGroupCode: number;
  jobTitleCodes: number[];

  constructor(vo: IJobGroupWithTitlesVO) {
    this.jobGroupCode = vo.jobGroupCode;
    this.jobTitleCodes = vo.jobTitleCodes ?? [];
  }
}
